import { useCallback } from 'react';
import useFetch from 'use-http';
import { normalizeLeaseRecordWhitespace } from './leaseRecordWhitespace';

// Only Lease Records writes are normalized. Some dialogs also read other APIs.
export default function useLeaseRecordsFetch() {
    const fetch = useFetch();
    const { post, put } = fetch;
    const normalizedPost = useCallback(
        (path: string, body?: object) =>
            body === undefined ? post(path) : post(path, path.startsWith('/v1.0/leases/') ? normalizeLeaseRecordWhitespace(body) : body),
        [post]
    );
    const normalizedPut = useCallback(
        (path: string, body?: object) =>
            body === undefined ? put(path) : put(path, path.startsWith('/v1.0/leases/') ? normalizeLeaseRecordWhitespace(body) : body),
        [put]
    );
    return { ...fetch, post: normalizedPost, put: normalizedPut };
}



// WEBPACK FOOTER //
// ./src/components/leases/useLeaseRecordsFetch.ts